<div class="row justify-content-between ff">
  <main class="col-8" id="mainContent">
    <article class="mb-4" *ngFor="let data of blocks">
      <ng-container *ngIf="data.note_status === 1">
        <h1 class="sr-only">Home</h1>
        <h2 class="h2 mb-2 text-truncate">{{data.title}}</h2>
        <div [innerHtml]="data.description"></div>
      </ng-container>
    </article>
  </main>

  <aside class="col-md-4 col-lg-3 archive" *ngIf="showPublishedTaxonomy">
    <section>
      <h2 class="h2 mb-3 text-truncate" id="recentlypublished">Recently Published</h2>
  
      <article class="w-100 archive--list mb-2" id="{{taxonomy.title.split(' ').join('')}}"
        *ngFor="let taxonomy of taxonomyList">
  
        <h3 class="h3 mb-0"><button type="button" (click)="navigateTaxonomy(taxonomy);"
            class="nav-link col text-left p-0 btn btn-clear font-4x font-bold active text-truncate">{{taxonomy.title}}</button></h3>
        <p class="mb-2">Taxonomy</p>
  
      </article>
    </section>
  </aside>
</div>